export { default as BaseTabs } from './_base-tabs.vue';
export * from './types/Tab';
